import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip } from 'antd'
import Loading from '../../shared/Loading'
import ShiftMessagingIndicator from '../../shared/ShiftMessagingIndicator'

const TooltipIconButton = ({
  disabled = false, dotStatus = 0, ghost, icon, iconColor, loading, overlayStyle = {}, placement = 'top', size = 'default', style, text, title, type = 'default',
  onClick = () => {}, onMouseEnter = () => {}, onMouseLeave = () => {}
}) => {
  return (
    <Tooltip title={title} overlayStyle={overlayStyle} placement={placement}>
      <Button
        className='flex-button'
        disabled={disabled}
        ghost={ghost}
        size={size}
        style={style}
        type={type}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {!loading && (
          <FontAwesomeIcon icon={icon} color={iconColor} />
        )}
        {loading && <Loading />}
        {text && <span> &nbsp; {text}</span>}
        {dotStatus > 0 && <ShiftMessagingIndicator status={dotStatus} />}
      </Button>
    </Tooltip>
  )
}

export default TooltipIconButton
